import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MedicationFinderSavingsComponent } from './medication-finder-savings.component';
import { DlsCalloutCardModule } from '@zelis/dls/callout-card';
import { DlsIconModule } from '@zelis/dls/icons';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { DlsButtonModule } from '@zelis/dls/button';
import { DlsSkeletonLoaderModule } from '@zelis/dls/skeleton-loader';

@NgModule({
  declarations: [MedicationFinderSavingsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    DlsCalloutCardModule,
    PageContainerModule,
    DlsButtonModule,
    DlsIconModule,
    DlsSkeletonLoaderModule,
  ],
  providers: [],
  exports: [MedicationFinderSavingsComponent],
})
export class MedicationFinderSavingsModule {}
